module.exports = __webpack_public_path__ + "img/ff-analytics.57db72ab.jpg";